import actionType from "../actionTypes";

const reducerName = actionType.reduxUpdateLearningAdminState;
const base = "/api/admin/learning";

const req =
  (actionKey, method, urlOrFn) => (componentRequest) => (dispatch) => {
    const url =
      typeof urlOrFn === "function"
        ? urlOrFn(componentRequest)
        : urlOrFn;
    global.api.requestAPI({
      axiosParams: { method, url },
      actionType: actionKey,
      reducerName,
      dispatch,
      componentRequest,
    });
  };

export default {
  reportsOverview: req(actionType.learning_admin.reportsOverview, "get", `${base}/reports/overview`),
  promptsList: req(actionType.learning_admin.promptsList, "get", `${base}/prompts`),
  promptPatch: req(
    actionType.learning_admin.promptPatch,
    "patch",
    (cr) => `${base}/prompts/${encodeURIComponent(cr.params.promptType)}`
  ),
  promptTest: req(
    actionType.learning_admin.promptTest,
    "post",
    (cr) => `${base}/prompts/${encodeURIComponent(cr.params.promptType)}/test`
  ),
  generationRunsList: req(
    actionType.learning_admin.generationRunsList,
    "get",
    `${base}/generation-runs`
  ),
  generationRunRetry: req(
    actionType.learning_admin.generationRunRetry,
    "post",
    (cr) => `${base}/generation-runs/${encodeURIComponent(cr.params.id)}/retry`
  ),
  deliveriesList: req(actionType.learning_admin.deliveriesList, "get", `${base}/deliveries`),
  qualityFeedbackList: req(
    actionType.learning_admin.qualityFeedbackList,
    "get",
    `${base}/quality-feedback`
  ),
  qualityFeedbackCreate: req(
    actionType.learning_admin.qualityFeedbackCreate,
    "post",
    `${base}/quality-feedback`
  ),
  guardrailFailuresList: req(
    actionType.learning_admin.guardrailFailuresList,
    "get",
    `${base}/guardrail-failures`
  ),
  guardrailFailureCreate: req(
    actionType.learning_admin.guardrailFailureCreate,
    "post",
    `${base}/guardrail-failures`
  ),
  featureFlagsList: req(actionType.learning_admin.featureFlagsList, "get", `${base}/feature-flags`),
  featureFlagsPatch: req(actionType.learning_admin.featureFlagsPatch, "patch", `${base}/feature-flags`),
  auditLogsList: req(actionType.learning_admin.auditLogsList, "get", `${base}/audit-logs`),
  patternsRebuild: req(actionType.learning_admin.patternsRebuild, "post", `${base}/patterns/rebuild`),
};
